import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { ArrowBackIosNew } from '@mui/icons-material'
import { useSearchParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import axios from 'axios'
import { API_ENDPOINT } from '../../../../constants/constants'
import YesNoDialog from "../../../widgets/ratulModal/YesNoDialog";
const AssessmentInfo = (props)=>{
    const {ended, socket, config, currentQn, setCurrentQn, num, onFinishAssessment, linkCode, ma, setMa, a, name} = props
    let attemptedQns = ma.filter(a=>a.status==="attempted").length;
    //console.log(attemptedQns,"attemptedQns",num);
    const [confirmOpen, setConfirmOpen] = useState(false)
    const [onConfirmAction, setOnConfirmAction] = useState(() => () => {})

    const askConfirmation = (callback) => {
      setOnConfirmAction(() => callback)
      setConfirmOpen(true)
    }
    const handleConfirm = () => {
      setConfirmOpen(false)
      onConfirmAction()
    }

    const isAnswered = (qnIndex) => {
      return ma[qnIndex - 1]?.status === "attempted"; // Adjust logic if "status" isn't reliable
    };
    //console.log(config);
    const confirmProceed = (callback) => {
      if (window.confirm("You haven't answered this question. Do you want to proceed?")) {
        callback();
      }
    };
    
    const goNext = () => {
      if (currentQn < num) {
        if (config.allowBack || isAnswered(currentQn)) {
          setCurrentQn(currentQn + 1)
        } else {
          askConfirmation(() => setCurrentQn(currentQn + 1))
        }
      }
    }
  
    const goPrev = () => {
      if (currentQn > 1) {
        // No confirmation needed for back since allowBack is true
        setCurrentQn(currentQn - 1)
      }
    }
  
    const handleFinish = () => {
      if (config.allowBack || isAnswered(currentQn)) {
        onFinishAssessment()
      } else {
        askConfirmation(() => onFinishAssessment())
      }
    }    
    
    return (
      <>
        {config.allowBack ? (
          <div className="buttons">
            {currentQn > 1 && (
              <button onClick={goPrev} className="prev-btn">
                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="13" viewBox="0 0 9 13" fill="none">
                  <path d="M6.79508 12.5L8.20508 11.09L3.62508 6.5L8.20508 1.91L6.79508 0.5L0.795078 6.5L6.79508 12.5Z" fill="#383838" />
                </svg>
                <span className="ms-1">Previous</span>
              </button>
            )}

            {currentQn < a.numQns && (
              <button onClick={goNext} className="next-btn">
                <span className="ms-1">Next</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="13" viewBox="0 0 9 13" fill="none">
                  <path d="M2.20508 0.5L0.795078 1.91L5.37508 6.5L0.795078 11.09L2.20508 12.5L8.20508 6.5L2.20508 0.5Z" fill="#ffffff" />
                </svg>
              </button>
            )}
  
            {currentQn === num && (
              <button onClick={handleFinish} className="finish-btn">
                Finish
              </button>
            )}
          </div>
        ) : (
          <>
            {currentQn < a.numQns && (
              <button onClick={goNext} className="next-btn">
                <span className="ms-1">Next</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="13" viewBox="0 0 9 13" fill="none">
                  <path d="M2.20508 0.5L0.795078 1.91L5.37508 6.5L0.795078 11.09L2.20508 12.5L8.20508 6.5L2.20508 0.5Z" fill="#ffffff" />
                </svg>
              </button>
            )}
  
            {currentQn === num && (
              <div className="buttons">
                <button onClick={onFinishAssessment} className="finish-btn">
                  Finish
                </button>
              </div>
            )}
          </>
        )}
        {/* Styled Confirmation Modal */}
        <YesNoDialog
                dopen={confirmOpen}
                message="You can't answer this question later. Are you sure you want to continue?"
                onNoResponse={() => setConfirmOpen(false)}
                onYesResponse={handleConfirm}
                setDopen={setConfirmOpen}
              />
      
      </>
    )
  }
export default AssessmentInfo